import React, { ReactDOM, useEffect, useState } from "react";
import { Suspense } from "react";
import { Box, Spinner } from "@chakra-ui/react";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import CuLogo from "../../assets/images/resources/cu-logo-head.png";
import GccLogo from "../../assets/images/resources/cu-logo-tree-foot.png";
import CuPng from "../../assets/images/resources/cu_icon.png";
import FullCuLogo from "../../assets/images/resources/cu_logo.png";
import BackgroundImage from "../../assets/images/resources/Sample format-1.png";
import Draft from "../../assets/images/resources/draft.png";
import Rollbacked from "../../assets/images/resources/rollback.png";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import isAllowed from "../../routing/isAllowed";
import TextProcil from "../../assets/images/resources/TEXPROCIL-Logo.png";
// Register font

const styles = StyleSheet.create({
  pageBackground: {
    position: "absolute",
    minWidth: "100%",
    minHeight: "100%",
    height: "150%",
    width: "150%",
    display: "block",
    zIndex: 100000,
    top: -15,
    opacity: 0.5,
  },

  container: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    height: "auto",
    border: "0.7pt solid #000",
  },
  leftView: {
    flex: 0.7,
    padding: 10,
  },
  rightView: {
    flex: 0.3,
    display: "flex",
    flexDirection: "column",
    // paddingTop: "1pt",
    borderLeft: "0.5 solid #000",
  },
  rightChildBox: {
    flex: 1,
    // marginBottom: "2pt",
    borderBottom: "0.5 solid #000",
  },

  rightChildtext: {
    paddingTop: "5pt",
    fontSize: "10px",
    paddingHorizontal: "10pt",
  },

  rightTextParent: {
    paddingLeft: "5pt",
    fontSize: "12px",
    fontWeight: "bold",
  },

  footer: {
    position: "absolute",
    height: 125,
    bottom: 0,
    left: 0,
    right: 0,
  },

  pageWrapper: {
    paddingBottom: 125,
    // marginTop: 30,
    // paddingTop: 30,
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderTopStyle: "solid",
  },
  logos: {
    width: "60px",
    height: "60px",
    marginTop: 5,
    marginBottom: 10,
    marginLeft: 20,
  },
  page: {
    // fontFamily: "Roboto",
    fontSize: 12,
    // paddingTop: 20,
    paddingHorizontal: 10,
    background: `url(${BackgroundImage})`,
    backgroundSize: "cover",
  },

  table: {
    width: "100%",
    marginTop: 0,
    marginBottom: 10,
    border: "0.5 solid #000",
  },

  tableRow: {
    flexDirection: "row",
    marginBottom: 0, // Remove the bottom margin
  },

  tableRowNew: {
    flexDirection: "row",
    border: "0.7pt solid #000",
    marginTop: "5px",
  },

  tableCell: {
    width: "50%",
    padding: 8,
    border: "0.5 solid #000",
  },

  fullWidthCell: {
    width: "100%",
    padding: 8,
    border: "0.5 solid #000",
    flex: 5, // Add this line to allow cells to expand
  },

  text: {
    fontSize: 12,
  },

  header: {
    marginBottom: 10,
    textAlign: "center",
  },

  headLogoWarp: {
    alignItems: "center", // Center the logo horizontally
    marginBottom: "10px", // Add space between logo and heading text
  },

  headLogo: {
    width: "50px",
  },

  footerLogo: {
    width: "100px",
    // padding: "10px"
  },

  // footerWarp: {
  //   position: 'absolute',
  //   height: 190,
  //   bottom: 0,
  //   left: 0,
  //   right: 0,
  // },

  footerWarp: {
    // position: "absolute",
    // height: 190,
    width: "100%",
    display: "flex",
    textAlign: "justify",
    // marginLeft: "5%",
    bottom: 0,
    left: 0,
    right: 0,
    color: "grey",
  },

  // footer: {
  //   width: "90%",
  // },

  footerDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
  },

  footerLg: {
    width: "350px",
  },

  footerLgText: {
    marginBottom: "5px",
  },

  heading: {
    width: "80%",
    marginBottom: 5, // Adjusted margin
    alignSelf: "center",
    textAlign: "center",
  },

  subheading: {
    width: "80%",
    margin: 0, // Adjusted margin
    alignSelf: "center",
    textAlign: "center",
  },

  textParent: {
    fontSize: "10px",
    fontWeight: "bold", // Apply bold font weight here
    overflow: "hidden", // Hide overflowing content
    whiteSpace: "pre-wrap", // Allow text to wrap to new lines
  },

  textChild: {
    marginLeft: "15px",
    marginTop: "1px",
    fontSize: "10px",
  },

  boxHead: {
    // marginBottom: "10px",
  },

  lastBoxHead: {
    // marginBottom: "0px",
  },
});

const nestedTableStyles = StyleSheet.create({
  nestedTable: {
    flexDirection: "row",
    marginBottom: 0,
  },
  nestedTableCell: {
    width: "15%",
    height: "auto",
    borderWidth: 1,
    borderColor: "black",
    borderLeftWidth: 1,
    borderLeftColor: "black",
    borderRightWidth: 1,
    borderRightColor: "black",
    borderTopWidth: 1,
    borderTopColor: "black",
    borderBottomWidth: 1,
    borderBottomColor: "black",
    paddingLeft: "1pt",
  },
});

const another = StyleSheet.create({
  nestedTable: {
    flexDirection: "row",
    marginBottom: 0,
  },
  nestedTableCell: {
    width: "33.33%",
    paddingHorizontal: "3pt",
    paddingVertical: "2pt",
    maxWidth: "33.33%",
  },
  nestedTableCellDocText: {
    overflow: "hidden", // Hide overflowing content
    whiteSpace: "pre-wrap", // Allow text to wrap to new lines
  },
});

const newStyles = StyleSheet.create({
  table: {
    display: "table",
    width: "100%",
    // borderCollapse: "collapse",
    border: "1px solid black",
    borderWidth: 1,
    borderColor: "black",
    fontSize: "8px",
    marginBottom: "5px",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
  },
  tableCell: {
    // width: "12.5%",
    borderRightColor: "#000",
    borderRightWidth: 1,
    padding: 5,
    wordWrap: "break-word",
  },
});

const currentDate = `${new Date(Date.now()).getDate()}-${
  new Date(Date.now()).getMonth() + 1
}-${new Date(Date.now()).getFullYear()}`;

const MyHeader = () => {
  return (
    <View style={styles.header} fixed>
      <View>
        <Image
          src={CuPng}
          style={{ width: "60", height: "60", margin: "auto" }}
        />
      </View>
    </View>
  );
};

const MyFooter = ({ tcData, qrCodeDataUri }) => {
  return (
    <View style={styles.footer} fixed>
      <View
        style={{
          width: "100%",
          height: "1px",
          border: "1 solid black",
        }}
      ></View>
      <View
        style={{
          fontSize: "8",
          marginTop: "5",
          textAlign: "center",
          paddingHorizontal: "40",
          color: "gray",
        }}
      >
        <Text>
          This electronically issued document is the valid original version.
          Please scan the QR-code to verify the integrity of this document. In
          view of possible hacking, the QR code of this certificate should
          always link to a website under the following domain: controlunion.com.
          If the QR code points to any other website, the certificate is forged.
        </Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: "8",
          color: "gray",
          paddingHorizontal: "10",
          justifyContent: "space-evenly",
        }}
      >
        <View style={{ width: "20%" }}>
          <Image
            src={CuLogo}
            style={{ width: "50", height: "50", margin: "auto" }}
          />
        </View>
        <View
          style={{
            width: "60%",
            borderLeft: "1px solid black",
            paddingLeft: "5px",
            marginTop: "10px",
          }}
        >
          <Text>CU Inspections & Certifications India Pvt. Ltd. </Text>
          <View style={{ marginTop: "2" }}>
            <Text>
              {" "}
              <Text style={{ color: "blue" }}>POST -</Text>{" "}
              <Text>
                {" "}
                22nd Floor,Arihant Aura, TTC Industrial Area, Turbhe MIDC,
                Opposite Turbhe Station, • 400705 • Navi Mumbai
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              fontSize: "8",
              marginTop: "2",
              justifyContent: "left",
            }}
          >
            <View style={{ flexDirection: "row" }}>
              <Text style={{ color: "blue" }}> T -</Text>
              <Text> +91 22 61294200</Text>
            </View>
            <View style={{ flexDirection: "row", marginLeft: "5px" }}>
              <Text style={{ color: "blue" }}>F -</Text>
              <Text> cuindia@controlunion.com</Text>
            </View>
          </View>
        </View>
        <View style={{ marginTop: "10px" }}>
          {qrCodeDataUri && (
            <Image
              style={{ width: "60", height: "60" }}
              allowDangerousPaths
              src={qrCodeDataUri}
            />
          )}
        </View>
      </View>
      {/*Removing this part because this was not in their tc template actually even footer was not their but need to include it since we are giving QR code*/}
      {/* <View
        style={{
          flexDirection: "row",
          fontSize: "8px",
          marginTop: "5px",
          textAlign: "center",
          justifyContent: "center",
          color: "grey",
        }}
      >
        <View>
          <Text>
            Transaction Certificate Number: {tcData?.tcApplicationNumber}
          </Text>
        </View>
        <View style={{ marginLeft: "5" }}>
          <Text>Seller Licence Number: {tcData?.tc_seller?.license}</Text>
        </View>
      </View> */}
    </View>
  );
};

const MyDocument = ({ tcData }) => {
  const inputs = tcData?.products?.flatMap((pro) =>
    pro?.inputs?.map((inp) => {
      return inp?.procurementId ? inp?.procurementId?.id : inp?.tcId?.tcNumber;
    })
  );

  const [qrCodeDataUri, setQrCodeDataUri] = useState(null);

  const generateQrCode = (id) => {
    if (id) {
      const qrCodeValue = `${process.env.REACT_APP_API_HOST}/traceability/${tcData?.tcNumber}`;
      const apiUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
        qrCodeValue
      )}&size=256x256`;

      fetch(apiUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            setQrCodeDataUri(reader.result);
          };
          reader.readAsDataURL(blob);
        });
    }
  };

  useEffect(() => {
    generateQrCode(tcData?._id);
  }, [tcData?._id]);

  // const currentDate = `${new Date(Date.now()).getDate()}-${
  //   new Date(Date.now()).getMonth() + 1
  // }-${new Date(Date.now()).getFullYear()}`;

  const PageWrapper = ({ children }) => {
    const hasBackground = tcData?.tc_approvedBy;

    return (
      <Page size="Letter" style={styles.pageWrapper}>
        {tcData?.status === "ROLLBACK" ? (
          <Image src={Rollbacked} style={styles.pageBackground} fixed />
        ) : hasBackground ? (
          <Image src={BackgroundImage} style={styles.pageBackground} fixed />
        ) : (
          <Image src={Draft} style={styles.pageBackground} fixed />
        )}

        <MyHeader tcData={tcData} />
        <View style={styles.content}>{children}</View>
        <MyFooter tcData={tcData} qrCodeDataUri={qrCodeDataUri} />
      </Page>
    );
  };

  return (
    <Document>
      {/* page 1 */}
      <PageWrapper>
        <View style={styles.page}>
          <View style={{}}>
            <View style={styles.heading}>
              <Text>
                TRANSACTION CERTIFICATE (TC) FOR TEXTILE PROCESSED ACCORDING TO
                THE{" "}
                {tcData?.tc_program?.name &&
                  tcData?.tc_program?.name.toUpperCase()}{" "}
                ({tcData?.tc_program?.id})
              </Text>
            </View>
          </View>
          <View style={[styles.header, { marginBottom: "5px" }]}>
            <View style={styles.subheading}>
              <Text>
                Transaction Certificate Number:{" "}
                <Text style={{ fontWeight: "bold" }}>{tcData?.tcNumber}</Text>
              </Text>
            </View>
          </View>

          {/* table */}
          <View style={styles.table}>
            {/* 1st row 1st box */}
            <View style={[styles.tableRow, { marginBottom: 0 }]} wrap={true}>
              <View style={styles.tableCell}>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    1a. Body issuing the certificate:
                  </Text>
                  <Text style={styles.textChild}>
                    CU Inspections & Certifications India Pvt. Ltd. 22nd Floor,
                    Arihant Aura, TTC Industrial Area, Turbhe MIDC, Opposite
                    Turbhe Station, 400705 Navi Mumbai India
                  </Text>
                </View>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    1b. Licensing code of the certification body:
                  </Text>
                  <Text style={styles.textChild}>
                    Place Holder for certification body License
                  </Text>
                </View>
              </View>

              {/* 1st row 2nd box */}
              <View style={styles.tableCell}>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    2a. Reference number of the certificate
                  </Text>
                  <Text style={styles.textChild}>{tcData?.tcNumber}</Text>
                </View>
                <View style={styles.boxHead}>
                  <Text style={[styles.textParent, { marginBottom: "5px" }]}>
                    2b. Reference number of the input transaction certificate:
                  </Text>
                  <View>
                    {inputs?.map((inp) => (
                      <Text
                        style={[
                          styles.textChild,
                          { marginBottom: 0, marginTop: 0 },
                        ]}
                      >
                        {inp}
                      </Text>
                    ))}
                  </View>
                </View>
              </View>
            </View>

            {/* 2nd row 1st box */}
            <View style={styles.tableRow} wrap={false}>
              <View style={styles.tableCell}>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    3a. Seller of the product(s):
                  </Text>
                  <Text style={styles.textChild}>
                    {`${tcData?.tc_seller?.name || ""}, ${
                      tcData?.tc_seller?.address?.raw_address || ""
                    }, ${tcData?.tc_seller?.address?.city || ""}, ${
                      tcData?.tc_seller?.address?.state || ""
                    }, ${tcData?.tc_seller?.address?.country || ""}, ${
                      tcData?.tc_seller?.address?.pinCode || ""
                    },`}
                  </Text>
                </View>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>
                    3b. License number of seller:
                  </Text>
                  <Text style={styles.textChild}>
                    {tcData?.tc_seller?.license || "N/A"}
                  </Text>
                </View>
              </View>

              {/* 2nd row box 2  */}
              <View style={styles.tableCell}>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>4. Inspection body:</Text>
                  <Text style={styles.textChild}>
                    CU Inspections & Certifications India Pvt. Ltd. 22nd
                    Floor,Arihant Aura, TTC Industrial Area, Turbhe MIDC,
                    Opposite Turbhe Station, 400705 Navi Mumbai India
                  </Text>
                </View>
              </View>
            </View>

            {/* 3rd row 1st box */}
            <View style={styles.tableRow} wrap={false}>
              <View style={styles.tableCell}>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    5a. Last processor of the product(s):
                  </Text>
                  <Text style={styles.textChild}>
                    {tcData?.tc_lastProcessor?.name
                      ? `${tcData?.tc_lastProcessor?.name}, ${
                          tcData?.tc_lastProcessor?.address?.raw_address || ""
                        }, ${tcData?.tc_lastProcessor?.address?.city || ""}, ${
                          tcData?.tc_lastProcessor?.address?.state || ""
                        }, ${
                          tcData?.tc_lastProcessor?.address?.country || ""
                        }, ${tcData?.tc_lastProcessor?.address?.pinCode || ""}`
                      : `${tcData?.lastProcessorDetails?.name || ""}, ${
                          tcData?.lastProcessorDetails?.address || ""
                        }, ${tcData?.lastProcessorDetails?.country || ""}`}
                  </Text>
                </View>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>
                    5b. License number of last processor:
                  </Text>
                  <Text style={styles.textChild}>
                    {" "}
                    {(tcData?.tc_seller && tcData?.tc_seller?.license) || "N/A"}
                  </Text>
                </View>
              </View>

              {/* 3rd row 2nd box */}
              <View style={styles.tableCell}>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>6. Country of dispatch:</Text>
                  <Text style={styles.textChild}>
                    {tcData?.tc_seller?.address?.country}
                  </Text>
                </View>
              </View>
            </View>

            {/* 4th row 1st box */}
            <View style={styles.tableRow} wrap={false}>
              <View style={styles.tableCell}>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    7a. Name of buyer of certified product(s):
                  </Text>
                  <Text style={styles.textChild}>
                    {tcData?.tc_buyer?.name
                      ? `${tcData?.tc_buyer?.name}, ${
                          tcData?.tc_buyer?.address?.raw_address || ""
                        }, ${tcData?.tc_buyer?.address?.city || ""}, ${
                          tcData?.tc_buyer?.address?.state || ""
                        }, ${tcData?.tc_buyer?.address?.country || ""}, ${
                          tcData?.tc_buyer?.address?.pinCode || ""
                        }`
                      : `${tcData?.buyerDetails?.name || ""}, ${
                          tcData?.buyerDetails?.address || ""
                        }, ${tcData?.buyerDetails?.country || ""}`}
                  </Text>
                </View>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>
                    7b. License number of buyer:
                  </Text>
                  <Text style={styles.textChild}>
                    {tcData?.tc_buyer?.license
                      ? tcData?.tc_buyer?.license
                      : "N/A"}
                  </Text>
                </View>
              </View>

              {/* 4th row 2nd box */}
              <View style={styles.tableCell}>
                <View style={styles.boxHead}>
                  <Text style={styles.textParent}>
                    8a. Consignee of the product:
                  </Text>
                  <Text style={styles.textChild}>
                    {tcData?.tc_consignee?.name
                      ? `${tcData?.tc_consignee?.name}, ${
                          tcData?.tc_consignee?.address?.raw_address || ""
                        }, ${tcData?.tc_consignee?.address?.city || ""}, ${
                          tcData?.tc_consignee?.address?.state || ""
                        }, ${tcData?.tc_consignee?.address?.country || ""}, ${
                          tcData?.tc_consignee?.address?.pinCode || ""
                        }`
                      : `${tcData?.consigneeDetails?.name || ""}, ${
                          tcData?.consigneeDetails?.address || ""
                        }, ${tcData?.consigneeDetails?.country || ""}`}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.tableCell} break={true}>
              <Text style={styles.textParent}>9. Country of consignee:</Text>
              <Text style={styles.textChild}>
                {tcData?.tc_consignee?.address?.country ||
                  tcData?.consigneeDetails?.country}
              </Text>
            </View>

            {/* 5th row box 1 */}
            <View break={true} style={styles.tableRow} wrap={false}>
              <View style={styles.fullWidthCell}>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>
                    10. Product and shipment information:
                  </Text>
                  <Text style={styles.textChild}>
                    Information is presented in box 12 of this TC
                  </Text>
                </View>
              </View>
            </View>

            {/* 6th row 1st box */}
            <View break={true} style={styles.tableRow} wrap={false}>
              <View style={styles.fullWidthCell}>
                <View style={styles.lastBoxHead}>
                  <Text style={styles.textParent}>
                    11. Declaration of the body issuing the certificate:
                  </Text>
                  <Text style={styles.textChild}>
                    This is to certify that, based on the relevant documentation
                    provided by the seller named in box 3 (i) the GCC Certified
                    material used for the products as further detailed /
                    referred to in box 10 and quantified in box 12 and13 has
                    been produced in accordance with GCC V1.0 and (ii) the
                    products have been processed in accordance with GCC
                    Verification Protocol. Compliance with the standard is
                    audited and monitored systematically under responsibility of
                    the certification body named in box 1.
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* keeping legacy table code for future reference purposes */}
          {/* <View
            break={true}
            render={({ pageNumber }) => (
              <View style={styles.table} break={pageNumber === 1}>
                <View style={styles.tableRow}>
                  <View style={styles.fullWidthCell}>
                    <View style={styles.lastBoxHead}>
                      <Text style={{ fontSize: 12 }}>
                        12. Continuation of box 10
                      </Text>
                    </View>
                  </View>
                </View>

                <View
                  style={{
                    paddingTop: "10pt",
                  }}
                >
                  <View style={{}}>
                    <View style={nestedTableStyles.nestedTable} wrap={false}>
                      <View
                        style={{
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                          paddingLeft: "1pt",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 8,
                          }}
                        >
                          Sr. No
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "125px",
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                          paddingLeft: "1pt",
                        }}
                      >
                        <Text style={{ fontSize: 8 }}>
                          Product category, details and composition
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "50px",
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                        }}
                      >
                        <Text style={{ fontSize: 8, padding: 5 }}>
                          Label grade
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "125px",
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                          paddingLeft: "1pt",
                          height: "auto",
                        }}
                      >
                        <Text style={{ fontSize: 8, padding: 5 }}>
                          Packed in
                        </Text>
                      </View>
                      <View style={nestedTableStyles.nestedTableCell}>
                        <Text style={{ fontSize: 8, padding: 5 }}>
                          Lot Nrs.
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "50px",
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                          paddingLeft: "1pt",
                        }}
                      >
                        <Text style={{ fontSize: 8, paddingTop: 5 }}>
                          Gross weight(KG)
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "50px",
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                          paddingLeft: "1pt",
                        }}
                      >
                        <Text style={{ fontSize: 8, padding: 5 }}>
                          Net weight(KG)
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "50px",
                          borderWidth: 1,
                          borderColor: "black",
                          borderLeftWidth: 1,
                          borderLeftColor: "black",
                          borderRightWidth: 1,
                          borderRightColor: "black",
                          borderTopWidth: 1,
                          borderTopColor: "black",
                          borderBottomWidth: 1,
                          borderBottomColor: "black",
                          paddingLeft: "1pt",
                        }}
                      >
                        <Text style={{ fontSize: 8, padding: 5 }}>
                          Certified weight(KG)
                        </Text>
                      </View>
                    </View>

                    {tcData?.products?.map((product, idx) => (
                      <View style={nestedTableStyles.nestedTable} wrap={false}>
                        <View
                          style={{
                            width: "25px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                          }}
                        >
                          <Text style={{ fontSize: 8, padding: 5 }}>
                            {idx + 1}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "125px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                            height: "auto",
                          }}
                        >
                          <Text style={{ fontSize: 8 }}>
                            {product?.productId?.product_productCategory.name}/
                          </Text>

                          <Text style={{ fontSize: 8 }}>
                            {
                              product?.productId?.product_productClassification
                                .name
                            }
                            :
                          </Text>
                          <Text
                            style={{
                              fontSize: 8,
                            }}
                          >
                            {`${product?.certifiedMaterial?.commodityId?.name}, ${product?.certifiedMaterial?.consumption}KG, (${product?.certifiedMaterial?.percentage}%)`}
                            +
                          </Text>
                          {product?.nonCertifiedMaterials?.length > 0
                            ? product?.nonCertifiedMaterials?.map(
                                (nonCertified) => (
                                  <Text
                                    style={{
                                      fontSize: 8,
                                    }}
                                  >
                                    {`${nonCertified?.commodityId?.name}, ${nonCertified?.consumption}KG, (${nonCertified?.percentage}%)`}
                                  </Text>
                                )
                              )
                            : ""}
                        </View>
                        <View
                          style={{
                            width: "50px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                          }}
                        >
                          <Text style={{ fontSize: 8, padding: 5 }}>
                            {
                              product?.productId?.product_certifiedLabelGrade
                                ?.name
                            }
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "125px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                            height: "auto",
                            flex: 1,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 8,
                              maxWidth: "125px",
                            }}
                          >
                            {product?.packedIn || "N/A"}
                          </Text>
                        </View>
                        <View style={nestedTableStyles.nestedTableCell}>
                          <Text style={{ fontSize: 8, padding: 5 }}>
                            {product?.lotNo || "N/A"}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "50px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                          }}
                        >
                          <Text style={{ fontSize: 8, padding: 5 }}>
                            {product?.grossWeight}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "50px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                          }}
                        >
                          <Text style={{ fontSize: 8, padding: 5 }}>
                            {product?.netWeight}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: "50px",
                            borderWidth: 1,
                            borderColor: "black",
                            borderLeftWidth: 1,
                            borderLeftColor: "black",
                            borderRightWidth: 1,
                            borderRightColor: "black",
                            borderTopWidth: 1,
                            borderTopColor: "black",
                            borderBottomWidth: 1,
                            borderBottomColor: "black",
                            paddingLeft: "1pt",
                          }}
                        >
                          <Text style={{ fontSize: 8, padding: 5 }}>
                            {product?.certifiedWeight}
                          </Text>
                        </View>
                      </View>
                    ))}
                  </View>
                </View>
              </View>
            )}
          /> */}

          <View break={true}>
            <View style={{ marginBottom: "5px" }}>
              <Text style={{ fontSize: 12 }}>12. Continuation of box 10</Text>
            </View>
            <View style={newStyles.table}>
              {/* Header Row */}
              <View style={newStyles.tableRow}>
                <View style={newStyles.tableCell}>
                  <Text>Sr. No</Text>
                </View>
                <View style={{ ...newStyles.tableCell, width: "160px" }}>
                  <Text>Product Category, details and composition</Text>
                </View>
                <View style={newStyles.tableCell}>
                  <Text>Label Grade</Text>
                </View>
                <View style={{ ...newStyles.tableCell, width: "160px" }}>
                  <Text>Packed In</Text>
                </View>
                <View style={newStyles.tableCell}>
                  <Text>Lot No</Text>
                </View>
                <View style={{ ...newStyles.tableCell, width: "50px" }}>
                  <Text>Certified Weight(KG)</Text>
                </View>
                <View style={{ ...newStyles.tableCell, width: "50px" }}>
                  <Text>Net Weight(KG)</Text>
                </View>
                <View style={{ ...newStyles.tableCell, width: "50px" }}>
                  <Text>Gross Weight(KG)</Text>
                </View>
              </View>

              {/* Data Rows */}
              {tcData?.products?.map((product, idx, array) => (
                <View
                  key={idx}
                  style={{
                    ...newStyles.tableRow,
                    borderBottomWidth: idx === array?.length - 1 ? 0 : 1,
                  }}
                >
                  <View style={{ ...newStyles.tableCell, width: "32.8px" }}>
                    <Text>{idx + 1}</Text>
                  </View>
                  <View style={{ ...newStyles.tableCell, width: "159.3px" }}>
                    <Text style={{ fontSize: 8 }}>
                      {product?.productId?.product_productCategory.name}/
                    </Text>

                    <Text style={{ fontSize: 8 }}>
                      {product?.productId?.product_productClassification.name}:
                    </Text>
                    <Text
                      style={{
                        fontSize: 8,
                      }}
                    >
                      {`${product?.certifiedMaterial?.commodityId?.name}, (${product?.certifiedMaterial?.percentage}%)`}
                    </Text>
                    {product?.nonCertifiedMaterials?.length > 0
                      ? product?.nonCertifiedMaterials?.map((nonCertified) => (
                          <Text
                            style={{
                              fontSize: 8,
                            }}
                          >
                            +{" "}
                            {`${nonCertified?.commodityId?.name}, (${nonCertified?.percentage}%)`}
                          </Text>
                        ))
                      : ""}
                  </View>
                  <View style={{ ...newStyles.tableCell, width: "54.6px" }}>
                    <Text style={{ fontSize: 8, padding: 5 }}>
                      {product?.productId?.product_certifiedLabelGrade?.name}
                    </Text>
                  </View>
                  <View style={{ ...newStyles.tableCell, width: "159.5px" }}>
                    <Text style={{ fontSize: 8, padding: 5 }} wrap={true}>
                      {product?.packedIn || "N/A"}
                    </Text>
                  </View>
                  {/* <View style={{ ...newStyles.tableCell, width: "34.6px" }}>
                    <Text
                      style={{ fontSize: 8, padding: 5, textOverflow:"wrap" }}
                    >
                      {product?.lotNo || "N/A"}
                      150,144 (-PR NO 14901-15000, 14376-14400)
                    </Text>
                  </View> */}
                  <View
                    style={{
                      ...newStyles.tableCell,
                      width: "100%",
                      maxWidth: "34.6px",
                      minHeight: "50px",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        // padding: 2,
                        flexWrap: "wrap",
                        flex: 1,
                      }}
                    >
                      {product?.lotNo || "N/A"}
                    </Text>
                  </View>

                  <View style={{ ...newStyles.tableCell, width: "49.7px" }}>
                    <Text style={{ fontSize: 8, padding: 5 }}>
                      {product?.certifiedWeight}
                    </Text>
                  </View>
                  <View style={{ ...newStyles.tableCell, width: "49.7px" }}>
                    <Text style={{ fontSize: 8, padding: 5 }}>
                      {product?.netWeight}
                    </Text>
                  </View>
                  <View style={{ ...newStyles.tableCell, width: "49.7px" }}>
                    <Text style={{ fontSize: 8, padding: 5 }}>
                      {product?.grossWeight}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>

          <View style={styles.tableRowNew} wrap={false}>
            <View style={styles.leftView}>
              <View style={styles.boxHead}>
                <Text style={styles.textParent}>
                  Product and shipment information:
                </Text>
                {[
                  ...new Set(
                    tcData.products.map(
                      (item) => item.productId?.product_productCategory?.name
                    )
                  ),
                ]
                  .filter(Boolean) // Remove undefined or empty values
                  .join(", ") // Join the categories with commas and space
                  .trim().length > 0 && ( // Trim extra spaces, if any
                  <Text style={styles.rightChildtext}>
                    {[
                      ...new Set(
                        tcData.products.map(
                          (item) =>
                            item.productId?.product_productCategory?.name
                        )
                      ),
                    ]
                      .filter(Boolean)
                      .join(", ")}{" "}
                  </Text>
                )}
                <Text style={styles.rightChildtext}>
                  Invoice No:{" "}
                  {Array.from(
                    new Set(tcData?.products?.map((item) => item.invoiceNo))
                  )
                    .map((invoiceNo) => invoiceNo)
                    .join(", ")}
                </Text>
                <Text style={styles.rightChildtext}>
                  Invoice Date:{" "}
                  {Array.from(
                    new Set(tcData?.products?.map((item) => item.invoiceDate))
                  )
                    .map((invoiceDate) =>
                      moment(invoiceDate).format("DD-MM-yyyy")
                    )
                    .join(", ")}
                </Text>
              </View>
            </View>

            <View style={styles.rightView}>
              <View style={styles.rightChildBox}>
                <Text style={{ fontSize: "10px", marginTop: 2 }}>
                  Total Net Weight (KG)
                </Text>
                <Text style={styles.textChild}>
                  {tcData?.totalNetWeight || 0} KG
                </Text>
              </View>

              <View style={styles.rightChildBox}>
                <Text style={{ fontSize: "10px", marginTop: 2 }}>
                  Total Gross Weight (KG)
                </Text>
                <Text style={styles.textChild}>
                  {tcData?.totalGrossWeight || 0} KG
                </Text>
              </View>

              <View style={styles.rightChildBox}>
                <Text style={{ fontSize: "10px", marginTop: 2 }}>
                  Total Certified Weight (KG)
                </Text>
                <Text style={styles.textChild}>
                  {tcData?.totalCertifiedWeight || 0} KG
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.tableRow} wrap={false}>
            <View style={[styles.fullWidthCell, { border: "0 solid" }]}>
              <View style={[styles.lastBoxHead]}>
                <Text style={{ fontSize: "10px" }}>Reference to documents</Text>
              </View>
            </View>
          </View>

          <View style={styles.tableRow} wrap={false}>
            <View
              style={[
                styles.fullWidthCell,
                {
                  fontSize: 10,
                  border: "0 solid",
                  borderBottom: "0.5 solid black",
                },
              ]}
            >
              <View style={[another.nestedTable]}>
                {/* Row 1 */}
                <View style={another.nestedTableCell}>
                  <Text>Doc type</Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text>Name</Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text>Date</Text>
                </View>
                {/* ... Add more columns as needed */}
              </View>

              {/* another row */}
              <View style={another.nestedTable}>
                {/* Row 1 */}
                <View style={another.nestedTableCell}>
                  <Text>Transport Document</Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text style={another.nestedTableCellDocText}>
                    {tcData?.tc_transportDocuments?.[0]?.documentId ||
                      tcData?.transportDocName}
                  </Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text>
                    {moment(
                      tcData?.tc_transportDocuments?.[0]?.createdAt ||
                        currentDate
                    ).format("DD-MM-YYYY")}
                  </Text>
                </View>
                {/* ... Add more columns as needed */}
              </View>

              {/* another one */}
              <View style={another.nestedTable}>
                {/* Row 1 */}
                <View style={another.nestedTableCell}>
                  <Text>Invoice </Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text style={another.nestedTableCellDocText}>
                    {tcData?.tc_invoiceDocuments?.[0]?.documentId ||
                      tcData?.invoiceDocName}
                  </Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text>
                    {Array.from(
                      new Set(tcData?.products?.map((item) => item.invoiceDate))
                    )
                      .map((invoiceDate) =>
                        moment(invoiceDate).format("DD-MM-yyyy")
                      )
                      .join(", ")}
                  </Text>
                </View>
                {/* ... Add more columns as needed */}
              </View>

              {/* another one more */}
              <View style={another.nestedTable}>
                {/* Row 1 */}
                <View style={another.nestedTableCell}>
                  <Text>Other</Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text style={another.nestedTableCellDocText}>
                    {tcData?.tc_documents?.[0]?.documentId ||
                      tcData?.documentsName}
                  </Text>
                </View>
                <View style={another.nestedTableCell}>
                  <Text>
                    {moment(
                      tcData?.tc_documents?.[0]?.createdAt || currentDate
                    ).format("DD-MM-yyyy")}
                  </Text>
                </View>
                {/* ... Add more columns as needed */}
              </View>
            </View>
          </View>

          <View style={styles.tableRow} wrap={false}>
            <View style={styles.fullWidthCell}>
              <View style={styles.lastBoxHead}>
                <Text style={{ fontSize: 8 }}>
                  13. This transaction certificate does not entitle the buyer /
                  consignee of the goods to use the GCC logo or make reference
                  to GCC. The rules for the labelling of GCC certified product
                  are outlined in the "Licensing and Labelling Guide".
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.tableRow} wrap={false}>
            <View style={styles.fullWidthCell}>
              <View style={styles.lastBoxHead}>
                <Text style={{ fontSize: "10px" }}>
                  14. Signature of the authorized person:
                </Text>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    margin: "5px",
                    fontSize: "8px",
                  }}
                >
                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Text>QR Code</Text>

                    <Image
                      allowDangerousPaths
                      src={qrCodeDataUri}
                      style={styles.logos}
                    />
                  </View>
                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Text>Stamp of the issuing body</Text>
                    <Image src={CuLogo} style={styles.logos} />
                  </View>
                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Text>Logo of the Scheme Owner</Text>
                    <Image
                      src={TextProcil}
                      style={{ width: "170", height: "60" }}
                    />
                  </View>
                </View>

                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "50%",
                  }}
                >
                  <View style={{ width: "71%", fontSize: "12px" }}>
                    <Text style={{ fontSize: "10px" }}>
                      This electronically issued document is the valid original
                      version.
                    </Text>
                    <Text style={{ paddingTop: "5pt", fontSize: "10px" }}>
                      On behalf of the Managing Director{" "}
                    </Text>
                    <Text style={{ fontSize: "10px" }}>{`${
                      tcData?.approvedBy
                        ? `${tcData?.tc_approvedBy.name} Certifier`
                        : "Not Approved Yet"
                    }`}</Text>
                    <Text style={{ fontSize: "10px" }}>
                      TC issued at:{" "}
                      {tcData?.approvedAt
                        ? moment(tcData.approvedAt).format("MMMM Do YYYY")
                        : "Awaiting final review"}
                    </Text>
                  </View>
                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: "8px",
                    }}
                  >
                    <Text>Standard's Logo</Text>
                    <Image src={GccLogo} style={styles.logos} />
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </PageWrapper>
    </Document>
  );
};

const TCnew = ({ tcData }) => {
  return (
    <div style={{ height: "100vh" }}>
      <Suspense
        fallback={
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <Spinner width="50px" height="50px" color="#3958DC" />
            <Text marginLeft="10px">Loading the TC...</Text>
          </Box>
        }
      >
        <PDFViewer style={{ width: "100%", height: "100%" }}>
          <MyDocument tcData={tcData} />
        </PDFViewer>
      </Suspense>
    </div>
  );
};

export default TCnew;
